<template>
  <div class="ren-common-preview" :data-component-type="component.type">
    {{ component.title || component.type }}
  </div>
</template>

<script setup lang="ts">
import type { RenDecorationComponent, RenDecorationPreviewData, RenDecorationThemeTokens } from '../../types'

defineProps<{
  component: RenDecorationComponent
  componentData?: unknown
  previewData?: RenDecorationPreviewData
  themeColor?: string
  themeTokens?: RenDecorationThemeTokens
}>()
</script>

<style scoped>
.ren-common-preview {
  min-height: 42px;
  display: grid;
  place-items: center;
  color: var(--rr-color-text-muted);
  font-size: var(--rr-font-size-sm);
}
</style>
